// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import DebitLaborPanel from './debit-labor-panel';
import DebitOtherCreditsPanel from './debit-other-credits-panel';
import DebitPartsPanel from './debit-parts-panel';
import {FormattedMessage} from 'react-intl';
import PartialDebitInfoPanel from './partial-debit-info-panel';
import PartialDebitModal from './partial-debit-modal';
import SpecialAllowanceDebitPanel from './debit-special-allowance-panel';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

function onConfirm() {

    const endPoint = 'https://dlrdoc.deere.com/ag_cust_supp/claimDebit';

    window.open(endPoint, '_blank');

    this.goBack();

}

function handleConfirmationModalClose() {

    this.actions.updateConfirmationModalVisibility(false);
    this.goBack();

}

function openPartialDebitModal() {

    this.actions.updatePartialDebitModalVisibility(true);

}

function cancelPartialDebit() {

    this.actions.completePartialDebit(this.queryParams.auditNumber);

}

class PartialDebit extends Component {

    componentWillMount() {

        if (this.props.queryParams.claimNumber) {

            this.props.actions.readPartialDebit(this.props.queryParams.claimNumber);
            this.props.actions.readAdjustmentTypes();

        }

    }

    componentWillUnmount() {

        this.props.actions.updatePartialDebitModalVisibility(false);
        this.props.actions.updateConfirmationModalVisibility(false);
        this.props.actions.resetPartialDebit();

    }

    render() {

        const hasCompanyContributionChanged = this.props.debit.specialAllowancePartialDebit.companyContribution !== this.props.debit.specialAllowancePartialDebit.changedCompanyContribution;
        const hasValueOfAdjustmentChanged = this.props.debit.partialDebit.every(debit => debit.valueOfAdjustment === null);
        const showSpecialAllowanceFields = this.props.debit.claimType.key === 'ZSPA' && this.props.debit.specialAllowanceType.key !== '12';
        const isSubmitDisabled = showSpecialAllowanceFields ? !hasCompanyContributionChanged : hasValueOfAdjustmentChanged;

        return (
            <section className='partial-debit'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='partial-debit-header'>
                    <h2>
                        <FormattedMessage
                            id='DEBIT_FOR_CLAIM_NUMBER'
                            values={{
                                claimNumber: formatClaimNumber(this.props.debit.claimNumber)
                            }}
                        />
                    </h2>
                    <div className='button-group'>
                        <button
                            onClick={this.props::cancelPartialDebit}
                        >
                            <FormattedMessage id='CANCEL'/>
                        </button>
                        <button
                            className='primary'
                            disabled={isSubmitDisabled}
                            onClick={this.props::openPartialDebitModal}
                        >
                            <FormattedMessage id='SUBMIT'/>
                        </button>
                    </div>
                </div>
                <PartialDebitInfoPanel/>
                {showSpecialAllowanceFields ?
                    <SpecialAllowanceDebitPanel/> :
                    <div className='debit-items'>
                        <DebitPartsPanel/>
                        <DebitLaborPanel/>
                        <DebitOtherCreditsPanel/>
                    </div>
                }
                <ConfirmationModal
                    confirmMessage='DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS'
                    isOpen={this.props.isConfirmationModalVisible}
                    onClose={this.props::handleConfirmationModalClose}
                    onConfirm={this.props::onConfirm}
                    title='PARTIAL_DEBIT'
                />
                <PartialDebitModal
                    queryParams={this.props.queryParams}
                />
            </section>
        );

    }

}

PartialDebit.displayName = 'PartialDebit';
PartialDebit.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    debit: PropTypes.instanceOf(Debit).isRequired,
    goBack: PropTypes.func.isRequired,
    isConfirmationModalVisible: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default PartialDebit;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/partial-debit.js